import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ClipboardList, Compass } from 'lucide-react';
export function TrustMiniSection() {
  const cards = [{
    Icon: MessageCircle,
    title: 'Todo en español',
    desc: 'Sin barreras de idioma ni procesos confusos. Te guiamos desde el inicio hasta el lanzamiento.'
  }, {
    Icon: ClipboardList,
    title: 'Proceso guiado paso a paso',
    desc: 'Sabes exactamente qué sigue, qué necesitas y cuánto tiempo toma cada etapa.'
  }, {
    Icon: Compass,
    title: 'Opciones según donde estás',
    desc: '¿Solo necesitas la empresa? ¿O salir con todo listo? Tú eliges según tu etapa actual.'
  }];
  return <section style={{
    background: 'linear-gradient(135deg, #f8f4ff 0%, #f3eeff 50%, #faf7ff 100%)',
    padding: '80px 24px'
  }} data-id="element-521">
      <div className="max-w-6xl mx-auto" data-id="element-522">
        <div className="text-center mb-12 md:mb-14" data-id="element-523">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[28px] md:text-[32px]" style={{
          color: '#2D1B4E',
          fontWeight: 800,
          textAlign: 'center',
          lineHeight: 1.2
        }} data-id="element-524">
            Una forma más{' '}
            <span className="italic" style={{
            background: 'linear-gradient(135deg, #5a4579, #8B6BA8)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent'
          }} data-id="element-525">
              inteligente
            </span>{' '}
            de empezar
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="mx-auto" style={{
          color: '#6B7280',
          fontSize: '16px',
          textAlign: 'center',
          maxWidth: '500px',
          marginTop: '12px',
          lineHeight: 1.6
        }} data-id="element-526">
            Diseñado para emprendedores latinos que quieren hacer las cosas bien
            desde el inicio
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-527">
          {cards.map(({
          Icon,
          title,
          desc
        }, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: '12px',
          padding: '12px',
          background: '#FFFFFF',
          border: '1px solid rgba(90, 69, 121, 0.12)',
          borderRadius: '16px',
          boxShadow: '0 4px 24px rgba(90, 69, 121, 0.07)',
          transition: 'all 0.3s ease'
        }} onMouseEnter={e => {
          const el = e.currentTarget as HTMLDivElement;
          el.style.borderColor = 'rgba(90, 69, 121, 0.3)';
          el.style.boxShadow = '0 12px 40px rgba(90, 69, 121, 0.12)';
          el.style.transform = 'translateY(-4px)';
        }} onMouseLeave={e => {
          const el = e.currentTarget as HTMLDivElement;
          el.style.borderColor = 'rgba(90, 69, 121, 0.12)';
          el.style.boxShadow = '0 4px 24px rgba(90, 69, 121, 0.07)';
          el.style.transform = 'translateY(0)';
        }} data-id="element-528">
              <div className="flex items-center justify-center flex-shrink-0" style={{
            width: '40px',
            height: '40px',
            minWidth: '40px',
            background: 'linear-gradient(135deg, rgba(90,69,121,0.08), rgba(90,69,121,0.04))',
            border: '1px solid rgba(90,69,121,0.1)',
            borderRadius: '10px'
          }} data-id="element-529">
                <Icon style={{
              color: '#5a4579'
            }} size={20} strokeWidth={1.5} data-id="element-530" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-531">
                <h3 style={{
              color: '#2D1B4E',
              fontSize: '15px',
              fontWeight: 700,
              marginBottom: '4px',
              lineHeight: 1.3
            }} data-id="element-532">
                  {title}
                </h3>
                <p style={{
              color: '#6B7280',
              fontSize: '13px',
              lineHeight: 1.5
            }} data-id="element-533">
                  {desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}